import api from '../config/api';

const base = '/api/admin/web-banners';

/** Dashboard → Website Banners (admin-only on the server). */
const webBannerService = {
  async list({ page, status, search } = {}) {
    const params = {};
    if (page) params.page = page;
    if (status && status !== 'all') params.status = status;
    if (search) params.search = search;
    return (await api.get(base, { params })).data;
  },
  async options() {
    return (await api.get(`${base}/options`)).data;
  },
  async get(id) {
    return (await api.get(`${base}/${id}`)).data;
  },
  async create(body) {
    return (await api.post(base, body)).data;
  },
  async update(id, body) {
    return (await api.put(`${base}/${id}`, body)).data;
  },
  async remove(id) {
    await api.delete(`${base}/${id}`);
  },
  async duplicate(id) {
    return (await api.post(`${base}/${id}/duplicate`)).data;
  },
  async setActive(id, isActive) {
    await api.post(`${base}/${id}/active`, { isActive });
  },
  /** items: [{ bannerId, sortOrder }] */
  async reorder(items) {
    await api.put(`${base}/reorder`, { items });
  },
};

export default webBannerService;
